import React, {PureComponent} from 'react';
import './index.css';
import {withTranslation} from 'react-i18next';
import Loading from '../subComponents/GenericLoading/loading';
import editIcon from '../../assets/edit.png';
import trashIcon from '../../assets/trash.png';
import Button from 'react-bootstrap/Button';
import Connect from "react-redux/es/connect/connect";
import {getClasses, addClasses, alertSuccess, editClass, removeClass, getClass, alertError} from "../../actions";
import {
    dispatchOnClassesGetClasses,
    dispatchOnClassesGetClassesSuccess,
    dispatchOnClassesGetClassesFailure,
    dispatchOnClassesCreateClasses,
    dispatchOnClassesCreateClassesSuccess,
    dispatchOnClassesCreateClassesFailure,
    dispatchOnClassesEditClasses,
    dispatchOnClassesEditClassesSuccess,
    dispatchOnClassesEditClassesFailure,
    dispatchOnClassesEditModeChanged,
    dispatchOnClassesPropsChanged,
    dispatchOnClassesRemoveClasses,
    dispatchOnClassesRemoveClassesSuccess,
    dispatchOnClassesRemoveClassesFailure, dispatchOnClassesRemoveModeChanged,
} from "./functions";
import Pagination from "../subComponents/GenericPagination";
import Config from "../../config";
import ArrowRight from "../../assets/arrow-right.png";
import ArrowLeft from "../../assets/arrow-left.png";
import SuperModal from "../subComponents/GenericModal/superModal";
import {debug, find} from "../../utility/functions";
import {GET_SCHOOL_CLASSES} from "../../api";

class Classes extends PureComponent {

    // Native component functions

    componentDidMount() {
        this.onGetClasses()
    }

    // Custom component functions

    getClassToEdit = () => {
        const {classInfo} = this.props;
        return {
            id: find(classInfo, 'id'),
            info: find(classInfo, 'info'),
            password: find(classInfo, 'password'),
            name: find(classInfo, 'name'),
        }
    };

    // Fetches all classes from the api and dispatches functions to redux according to the result
    onGetClasses = (url) => {
        this.props.dispatchOnClassesGetClasses();
        getClasses(url)
            .then(this.props.dispatchOnClassesGetClassesSuccess)
            .catch(this.props.dispatchOnClassesGetClassesFailure)
    };

    onGetClass = (classInfo, index) => {
        getClass(find(classInfo, 'id'))
            .then(response => {
                this.props.dispatchOnClassesEditModeChanged(true, response.data, index)
            })
            .catch(error => {

            })
    };

    // This function attempts to add a new class with the data provided from the html page
    onAddClass = (body) => {
        const {creating, editing, removing} = this.props;

        if(creating || editing || removing) return null;

        this.props.dispatchOnClassesCreateClasses();
        addClasses(body)
            .then((response) => {
                alertSuccess(response.message);
                this.props.dispatchOnClassesCreateClassesSuccess(response)
            })
            .catch((error) => {
                alertError(error);
                this.props.dispatchOnClassesCreateClassesFailure(error)
            })
    };

    // This function attempts to edit an existing article with the data provided from the html page
    onEditClass = () => {
        const {creating, editing, removing} = this.props;

        if(creating || editing || removing) return null;

        const classInfo = this.getClassToEdit();
        this.props.dispatchOnClassesEditClasses();
        debug("Class to edit", classInfo)
        editClass(classInfo.id, classInfo)
            .then((response) => {
                debug("Edit class with success", response)
                alertSuccess(response.message);
                this.props.dispatchOnClassesEditClassesSuccess(response)
            })
            .catch(this.props.dispatchOnClassesEditClassesFailure)
    };

    // This function attempts to remove an existing class
    onRemoveClass = () => {
        const {classInfo, creating, editing, removing} = this.props;

        if(creating || editing || removing) return null;

        this.props.dispatchOnClassesRemoveClasses();
        removeClass(classInfo.id)
            .then((response) => {
                debug("Removed Class with success", response);
                alertSuccess(response.message);
                this.props.dispatchOnClassesRemoveClassesSuccess(response)
            })
            .catch(this.props.dispatchOnClassesRemoveClassesFailure)
    };

    // This function is called when the button 'Add' is clicked
    onAddClassesButtonClicked = (e) => {
        e.preventDefault();
        const {name, password, info} = this.props;
        const body = {
            name,
            password,
            info,
        };
        this.onAddClass(body);
    };

    // This function is called when the icon 'pencil' is clicked
    onEditPressed = (classInfo, index) => {
        this.onGetClass(classInfo, index)
    };

    // This function is called when the icon 'trash' is clicked
    onRemovePressed = (classInfo, index) => {
        this.props.dispatchOnClassesRemoveModeChanged(true, classInfo, index)
    };

    // This function is called when the name in the form to add a new class is changed
    onNameChanged = (e) => {
        this.props.dispatchOnClassesPropsChanged({
            name: this.replaceBlankSpaces(e.target.value),
        })
    };

    // This function is called when the password in the form to add a new class is changed
    onPasswordChanged = (e) => {
        this.props.dispatchOnClassesPropsChanged({
            password: e.target.value,
        })
    };

    // This function is called when the info in the form to add a new class is changed
    onInfoChanged = (e) => {
        this.props.dispatchOnClassesPropsChanged({
            info: e.target.value,
        })
    };

    // This function is called when the name in the form to edit an existing class is changed
    onClassInfoNameChanged = (e) => {
        const {classInfo} = this.props;
        this.props.dispatchOnClassesPropsChanged({
            classInfo: {...classInfo, account: {...find(classInfo, 'account'), name: this.replaceBlankSpaces(e.target.value)}}
        })
    };

    // This function is called when the password in the form to edit an existing class is changed
    onClassInfoPasswordChanged = (e) => {
        this.props.dispatchOnClassesPropsChanged({
            classInfo: {...this.props.classInfo, password: e.target.value}
        })
    };

    // This function is called when the info in the form to edit an existing class is changed
    onClassInfoInfoChanged = (e) => {
        this.props.dispatchOnClassesPropsChanged({
            classInfo: {...this.props.classInfo, info: e.target.value}
        })
    };

    // This function changes white spaces into underscores
    replaceBlankSpaces = (value) => {
        if (/\s/.test(value)) {
            return value.replace(" ", "_")
        }
        return value;
    };

    // Native component render function

    render() {
        const {t, loading} = this.props;

        if(loading) {
            return(
                <div align={'center'}>
                    <Loading size={"large-spinner"}/>
                </div>
            )
        }

        return (
            <div>
                <div className="container">
                    <div className="container-header">
                        <div className="container-header-tittle"><h2>{t('Classes')}</h2></div>
                    </div>
                    <div className="container-classes-body">
                        <div className="container-classes-body-classes-list">
                            {this.renderNoClasses()}
                            {this.renderClasses()}
                            {this.renderPagination()}
                        </div>
                        <div className="container-classes-body-classes-division"/>
                        <div className="container-classes-body-classes-add">
                            {this.renderNewClassForm()}
                        </div>

                    </div>
                </div>
                {this.renderEditModal()}
                {this.renderRemoveModal()}
            </div>
        );
    }

    renderNewClassForm(){
        const {t, name, password, info, creating} = this.props;
        return(
            <form autoComplete="off" onSubmit={this.onAddClassesButtonClicked}>
                <div className="container-classes-body-classes-add-form">
                    <div className="container-classes-body-classes-add-form-header">
                        {t('Adicionar Turma')}
                    </div>
                    <div>
                        <label className='input-label'>{t("User")}</label>
                        <input name="name" required={true}
                               className="container-classes-body-classes-add-form-account-name"
                               value={name} onChange={this.onNameChanged}
                               maxLength="64" placeholder={"ex: turma_10_a"}/>
                        <label className='input-label'>{t("Password")}</label>
                        <input name="password" required={true} type="password"
                               className="container-classes-body-classes-add-form-account-password"
                               value={password}
                               onChange={this.onPasswordChanged} maxLength="64"
                               placeholder={"Introduz uma " + t("Password")}/>
                        <label className='input-label'>{t("Description")}</label>
                        <textarea
                            name="info"
                            className="container-classes-body-classes-add-form-account-description"
                            value={info} onChange={this.onInfoChanged}
                            rows="10" cols="30" placeholder={"ex: Turma 10º A"}/>
                    </div>
                </div>
                <Button
                    className="container-classes-body-classes-add-form-buttom"
                    type="submit">{creating? <Loading size={"small-spinner"} color={"white"} /> : t('Add')}</Button>
            </form>
        )
    }

    renderPagination() {
        if(!this.props.pagination) return;
        const {current_page, last_page} = this.props.pagination;
        return (
            <Pagination
                totalPages={last_page}
                currentPage={current_page}
                baseUrl={Config.urlApi + GET_SCHOOL_CLASSES}
                onPageChanged={(url) => {
                    this.onGetClasses(url)
                }}
            />
        )
    }

    renderEditModal(){
        const {showEditModal, editing, classInfo, t} = this.props;
        if(showEditModal) {
            return(
                <SuperModal
                    okLoading={editing}
                    okButtonColor={'green'}
                    okButtonText={t("Save")}
                    onOkPressed={() => {
                        this.onEditClass()
                    }}
                    size={"lg"}
                    title={t("Edit Class")}
                    cancelButtonText={t("Cancel")}
                    onCancelPressed={() => {
                        this.props.dispatchOnClassesEditModeChanged(false, null, null)
                    }}
                    onCloseModal={() => {
                        this.props.dispatchOnClassesEditModeChanged(false, null, null)
                    }}
                >
                    <div className="container-classes-body-classes-edit">
                        <div>
                            <label className='input-label'>{t("User")}</label>
                            <input name="name" className="container-classes-body-classes-add-form-account-name" value={find(classInfo, 'name')} onChange={this.onClassInfoNameChanged} maxLength="64"  placeholder={t("Name")}/>
                            <label className='input-label'>{t("Password")}</label>
                            <input name="password" className="container-classes-body-classes-add-form-account-password" value={find(classInfo, 'password')} onChange={this.onClassInfoPasswordChanged} maxLength="64" placeholder={t("Password")}/>
                            <label className='input-label'>{t("Description")}</label>
                            <textarea name="info" className="container-classes-body-classes-add-form-account-description" value={find(classInfo, 'info')} onChange={this.onClassInfoInfoChanged} rows="10" cols="30" placeholder={t("Description")}/>
                        </div>
                    </div>
                </SuperModal>
            )
        }
    }
    renderRemoveModal(){
        const {showRemoveModal, removing, classInfo, t} = this.props;
        if(showRemoveModal) {
            return(
                <SuperModal
                    okLoading={removing}
                    okButtonColor={'red'}
                    okButtonText={t("Remove")}
                    onOkPressed={() => {
                        this.onRemoveClass()
                    }}
                    size={"sm"}
                    title={t("Remove Class")}
                    cancelButtonText={t("Cancel")}
                    onCancelPressed={() => {
                        this.props.dispatchOnClassesRemoveModeChanged(false, null, null)
                    }}
                    onCloseModal={() => {
                        this.props.dispatchOnClassesRemoveModeChanged(false, null, null)
                    }}
                >
                    <text>{find(classInfo, 'info')}</text>
                </SuperModal>
            )
        }
    }

    renderNoClasses() {
        const {t} = this.props;
        if (this.props.classes && this.props.classes.length > 0)
            return;

        return (
            <div id='no-classes'>
                <br></br>
                <h4>{t("No registered classes")}</h4>
                <p>{t("Add a new class using the form at your right")}</p>
            </div>
        );
    }

    renderClasses(){
        if(!this.props.classes) return;
        return this.props.classes.map((classInfo, index) =>
            <div key={'turma' + classInfo.id} className="classes-list-item">
                <div className="classes-list-item-name">
                    {classInfo.info}
                </div>

                <div id={classInfo.id.toString()} className="classes-list-item-action">
                    <img
                        alt=""
                        src={editIcon}
                        className="classes-list-item-action-icon-edit"
                        onClick={() => this.onEditPressed(classInfo, index)}
                    />
                    <img
                        alt=""
                        src={trashIcon}
                        className="classes-list-item-action-icon-trash"
                        onClick={() => this.onRemovePressed(classInfo, index)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    classes: store.classesReducer.classes,
    classInfo: store.classesReducer.classInfo,
    index: store.classesReducer.index,
    name: store.classesReducer.name,
    password: store.classesReducer.password,
    info:store.classesReducer.info,
    showEditModal: store.classesReducer.showEditModal,
    editing: store.classesReducer.editing,
    showRemoveModal: store.classesReducer.showRemoveModal,
    removing: store.classesReducer.removing,
    creating: store.classesReducer.creating,
    loading: store.classesReducer.loading,
    pagination: store.classesReducer.pagination,
});

const mapFunctionsToProps = {
    dispatchOnClassesGetClasses,
    dispatchOnClassesGetClassesSuccess,
    dispatchOnClassesGetClassesFailure,
    dispatchOnClassesCreateClasses,
    dispatchOnClassesCreateClassesSuccess,
    dispatchOnClassesCreateClassesFailure,
    dispatchOnClassesEditClasses,
    dispatchOnClassesEditClassesSuccess,
    dispatchOnClassesEditClassesFailure,
    dispatchOnClassesRemoveClasses,
    dispatchOnClassesRemoveClassesSuccess,
    dispatchOnClassesRemoveClassesFailure,
    dispatchOnClassesEditModeChanged,
    dispatchOnClassesRemoveModeChanged,
    dispatchOnClassesPropsChanged,
};

export default (Connect(mapStateToProps, mapFunctionsToProps)(withTranslation("translations")(Classes)));
